import type {KeyboardEventHandler, WheelEventHandler} from 'react'

export const blurNumberInputOnWheel: WheelEventHandler<HTMLInputElement> = (event) => {
  if (document.activeElement === event.currentTarget) {
    event.currentTarget.blur()
  }
}

export const preventNumberInputArrowStep: KeyboardEventHandler<HTMLInputElement> = (event) => {
  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
    event.preventDefault()
  }
}
